import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/primeng';



@Component({
    selector: 'top-menu',
    templateUrl: './top-menu.component.html',
    styleUrls: ['./top-menu.component.css']
})
export class TopMenuComponent implements OnInit {

    items: MenuItem[];

    constructor(private router: Router) { }

    ngOnInit() {
        this.initialize();
    }

    initialize() {
        this.items = [{
            label: 'ניהול נתונים',
            items: [
                { label: 'פרמטרים', routerLink: ['/home/parameters'] },
                { label: 'פרטי שירות', routerLink: ['/home/serviceItems'] },
                { label: ' תנאים', routerLink: ['/home/terms'] }
         
            ]
        }
        ];
    }
}



// WEBPACK FOOTER //
// ./src/app/components/home-page/top-menu/top-menu.component.ts